// 我要用到的一些接口
import service from "./request"
// 引入接口
// 如果在 JavaScript 中引入接口不需要进行类型标注
// import { ILoginData } from "@/type/login";
 
// 登录接口
export function index(data) {
    return service({
        url: "/index/index",
        method: "POST",
        data: data
    });
} 
export function getbanner(queryParams) {
    return service({
        url: "/api/v1/banner/banner",
        method: "GET",
        params: queryParams
    });
}
export function getrecruitment(queryParams) {
    return service({
        url: "/api/v1/recruitment/list",
        method: "GET",
        params: queryParams
    });
}
export function getrecruitmentdetails(queryParams) {
    return service({
        url: "/api/v1/recruitment/details",
        method: "GET",
        params: queryParams
    });
}
export function getrichTextlist(queryParams) {
    return service({
        url: "/api/v1/richText/list",
        method: "GET",
        params: queryParams
    });
}
export function getrichTextdetails(queryParams) {
    return service({
        url: "/api/v1/richText/details",
        method: "GET",
        params: queryParams
    });
}
export function getconfig(queryParams) {
    return service({
        url: "/api/v1/config/simple",
        method: "GET",
        params: queryParams
    });
}
export function getsimpleGroup(queryParams) {
    return service({
        url: "/api/v1/config/simpleGroup",
        method: "GET",
        params: queryParams
    });
}
export function seachRecruitment(queryParams) {
    return service({
        url: "/api/v1/recruitment/page",
        method: "GET",
        params: queryParams
    });
}
export function developmentCourse(queryParams) {
    return service({
        url: "/api/v1/developmentCourse/list",
        method: "GET",
        params: queryParams
    });
}